
export const tryCatch = (cb) => {
    try {return cb()} catch(e){}
}